export default __webpack_public_path__ + "static/media/warehouse-losses.6737a92c.svg";